export const FormatAmount = (amount, currency) => {
  try {
    const formatter = Intl.NumberFormat("en-IN", {
      style: "currency",
      currency
    });

    return formatter.format(amount / 100);
  } catch (error) {
    return `₹${amount / 100}`;
  }
};

export const FormatDate = dateStr => {
  const date = new Date(dateStr);
  try {
    return date.toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata"
    });
  } catch (error) {
    return date.toLocaleString();
  }
};
